<template>
  <b-form-group
    label="Açıklama"
    label-for="content"
  >
    <validation-provider
      #default="{ errors }"
      name="Açıklama"
      rules="required"
    >
      <quill-editor
        id="content"
        v-model="workItem.content"
        :options="editorOption"
        class="bg-white text-black-50"
      >
        <div
          id="content_toolbar"
          slot="toolbar"
        >
          <editor-toolbar />
        </div>
      </quill-editor>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'quill/dist/quill.core.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'

export default {
  name: 'ContentText',
  components: {
    BFormGroup,
    quillEditor,
    EditorToolbar,
    ValidationProvider,
  },
  data() {
    return {
      required,
      editorOption: {
        modules: {
          toolbar: '#content_toolbar',
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    workItem() {
      return this.$store.getters['serviceWorks/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
